import { render, staticRenderFns } from "./OnComparaison.vue?vue&type=template&id=52d6b8b2&"
import script from "./OnComparaison.vue?vue&type=script&lang=js&"
export * from "./OnComparaison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports